function setActivePriceTab(element) {
  var items = document.querySelectorAll(".plans__list .plan-data");
  items.forEach(function (item) {
    item.classList.remove("active");
  });
  element.classList.add("active");
}

//document.addEventListener("DOMContentLoaded", function () {
  // var items = document.querySelectorAll(".plans__list .plan-data");
  // items.forEach(function (item) {
  //   item.addEventListener("click", function () {
  //     var targetDataAttr = this.getAttribute("data-attr");
  //     var targetitems = document.querySelectorAll(
  //       ".tabs_details-content-inner .details-tab"
  //     );
  //     targetitems.forEach(function (targetitem) {
  //       targetitem.classList.remove("active");
  //     });
  //     var targetitemsactive = document.querySelector(
  //       '.tabs_details-content-inner [target-data-attr="' +
  //         targetDataAttr +
  //         '"]'
  //     );
  //     targetitemsactive.classList.add("active");
  //     setActivePriceTab(this);
  //   });
  // });
//});
document.addEventListener("DOMContentLoaded", function () {
  var checkbox = document.querySelector(".js-toggle-prices");
  if (checkbox) {
    checkbox.addEventListener("change", function () {
      var priceChangeitems = document.querySelectorAll(".plans__list .plan-data");
      priceChangeitems.forEach(function (priceItem) {
        if (checkbox.checked) {
          var monthlyPrice = priceItem
            .querySelector(".js-price-change")
            .getAttribute("data-monthly");
          var monthlyURL = priceItem
            .querySelector(".btn")
            .getAttribute("data-monthly");
          priceItem.querySelector(".js-price-change").innerHTML = monthlyPrice;
          priceItem.querySelector(".btn").href = monthlyURL;
          
        } else {
          var yearlyPrice = priceItem
            .querySelector(".js-price-change")
            .getAttribute("data-yearly");
          var yearlyURL = priceItem
            .querySelector(".btn")
            .getAttribute("data-yearly");
          priceItem.querySelector(".js-price-change").innerHTML = yearlyPrice;
          priceItem.querySelector(".btn").href = yearlyURL;
        }
      });
    });
  }
});